export default "__VITE_ASSET__DNr3HTDj__"